// 定义内容
export default {
    label: {
        one1: 'User name login',
        two2: 'Mobile number',
    },
    link: {
        one3: 'Third party login',
        two4: 'Links',
    },
    account: {
        accountPlaceholder1: 'The user name admin or not is common',
        accountPlaceholder2: 'Password: 123456',
        accountPlaceholder3: 'Please enter the verification code',
        accountBtnText: 'Sign in',
    },
    mobile: {
        placeholder1: 'Please input mobile phone number',
        placeholder2: 'Please enter the verification code',
        codeText: 'Get code',
        btnText: 'Sign in',
        msgText:
            'Warm tip: it is recommended to use Google, Microsoft edge, version 79.0.1072.62 and above browsers, and 360 browser, please use speed mode',
    },
    scan: {
        text: 'Open the mobile phone to scan and quickly log in / register',
    },
    signInText: 'welcome back!',
};